import { makeStyles } from 'tss-react/mui';

const useStylesControlButtonContainer: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  controlButtonContainer: {
    textAlign: 'right',
  },
  controlButtonContainerCentered: {
    textAlign: 'center',
  },
  controlButtonContainerTopOffset: {
    marginTop: 10,
  },
  controlButtonContainerLargeTopOffset: {
    marginTop: 20,
  },
  controlButtonContainerInvisible: {
    display: 'none',
  },
}));

export default useStylesControlButtonContainer;
